import type { Sprite } from 'pixi.js';
import { Texture, TilingSprite } from 'pixi.js';
import type { SpriteModel } from './types/models';
import { mapBlendMode } from './mapBlendMode';
import { setTextureWithLoadingFallback } from '../../propsMixin/dynamicTextureLoading';

export const copySpriteProps = (sprite: Sprite | TilingSprite, model: SpriteModel): void => {
  const scaleFactor = model.texture === 'WHITE' ? 1.6 : 1;

  const texture = model.texture === '' ? Texture.EMPTY : Texture.from(model.texture);

  sprite.x = model.x;
  sprite.y = model.y;
  sprite.anchor.x = model.anchor.x;
  sprite.anchor.y = model.anchor.y;

  if (sprite instanceof TilingSprite) {
    sprite.width = model.scale.x * texture.frame.width;
    sprite.height = model.scale.y * texture.frame.height;
  } else {
    sprite.scale.x = model.scale.x * scaleFactor;
    sprite.scale.y = model.scale.y * scaleFactor;
  }

  sprite.angle = model.angle;
  sprite.alpha = model.alpha;
  sprite.visible = model.visible;
  sprite.tint = model.tint;
  sprite.blendMode = mapBlendMode(model.blendMode);
  sprite.interactive = model.interactive;
  sprite.eventMode = model.buttonMode ? 'static' : 'auto';
  sprite.cursor = model.buttonMode ? 'pointer' : 'default';
  void setTextureWithLoadingFallback(sprite, model.texture, (model as { data?: { url?: string } }).data?.url);
};
